import React, { FC } from 'react';
import styles from './DeviceItemImage.module.scss';
import { SubjectImage } from 'components/SubjectImage/SubjectImage';
import { ICardProps } from 'components/Card/Card';
import { flattenContentfulData } from 'services/cms/flattenContentful';

export const DeviceItemImage: FC<ICardProps> = ({ entry, ...props }) => (
  <div className={styles.imageWrapper} {...props}>
    <SubjectImage entry={flattenContentfulData(entry)} className={styles.imageWrapperImage} />
  </div>
);
